'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _summaries = require('../actions/summaries');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchSummaries),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchSummary),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editSummary),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchSummariesRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchSummaryRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(editSummaryRequest);

function fetchSummaries(_ref) {
    var filter = _ref.filter;
    var disciplineId, response;
    return regeneratorRuntime.wrap(function fetchSummaries$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    disciplineId = filter.disciplineId;
                    _context.next = 4;
                    return (0, _effects.call)(_api.request, 'get', '/summaries?disciplineId=' + disciplineId);

                case 4:
                    response = _context.sent;
                    _context.next = 7;
                    return (0, _effects.put)(_summaries.actionCreators.fetchSummariesSucceeded(response.data, filter));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_summaries.actionCreators.fetchSummariesFailed('Ocorreu um erro na busca de resumos'));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchSummary(_ref2) {
    var summaryId = _ref2.summaryId;
    var response;
    return regeneratorRuntime.wrap(function fetchSummary$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/summaries/' + summaryId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_summaries.actionCreators.fetchSummarySucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_summaries.actionCreators.fetchSummaryFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editSummary(_ref3) {
    var summaryId = _ref3.summaryId,
        summary = _ref3.summary,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function editSummary$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'PUT', '/summaries/' + summaryId, summary);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_summaries.actionCreators.editSummarySucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_summaries.actionCreators.editSummaryFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function fetchSummariesRequest() {
    return regeneratorRuntime.wrap(function fetchSummariesRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_summaries.actionTypes.FETCH_SUMMARIES_REQUEST, fetchSummaries);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function fetchSummaryRequest() {
    return regeneratorRuntime.wrap(function fetchSummaryRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_summaries.actionTypes.FETCH_SUMMARY_REQUEST, fetchSummary);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function editSummaryRequest() {
    return regeneratorRuntime.wrap(function editSummaryRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_summaries.actionTypes.EDIT_SUMMARY_REQUEST, editSummary);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

exports.default = [fetchSummariesRequest, fetchSummaryRequest, editSummaryRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/summaries.js
// module id = 2236
// module chunks = 0